import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import Form from '../../../../../../form';
import EditDataButton from './components/EditDataButton';
import ElementStylesGroup from './components/ElementStylesGroup';
import StylesGroup from './components/StylesGroup';

var TableProperties = function TableProperties(_ref) {
  var selectedWidget = _ref.selectedWidget,
      cube = _ref.cube,
      dispatch = _ref.dispatch;

  var handlePropertyChange = function handlePropertyChange(sourcePropertyName, propertyName, value) {
    dispatch({
      type: 'change_widget_property',
      payload: {
        widgetId: selectedWidget.id,
        sourcePropertyName: sourcePropertyName,
        propertyName: propertyName,
        value: value
      }
    });
  };

  var handleCaptionChange = function handleCaptionChange(e) {
    handlePropertyChange('caption', 'title', e.target.value);
  };

  var getPropertyChangeHandler = function getPropertyChangeHandler() {
    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return function (propertyName, value) {
      return handlePropertyChange(source, propertyName, value);
    };
  };

  var handleClearStyles = function handleClearStyles(sourcePropertyName) {
    dispatch({
      type: 'clear_styles',
      payload: {
        widgetId: selectedWidget.id,
        sourcePropertyName: sourcePropertyName
      }
    });
  };

  return React.createElement(Grid, {
    container: true,
    direction: "column",
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, null, "Caption"), React.createElement(Form.Input.Text, {
    defaultValue: selectedWidget.caption.title,
    inputProps: {
      placeholder: 'Add caption...',
      onBlur: handleCaptionChange
    },
    onEnter: handleCaptionChange
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    gutterBottom: true
  }, "Data"), React.createElement(EditDataButton, {
    widget: selectedWidget,
    cube: cube
  }, "Select Data")), React.createElement(Grid, {
    item: true
  }, React.createElement("div", null, React.createElement(Form.Input.Checkbox, {
    checked: selectedWidget.caption.visibility !== 'Hidden',
    onChange: function onChange(e, checked) {
      return handlePropertyChange('caption', 'visibility', checked ? 'Visibile' : 'Hidden');
    },
    label: "Caption"
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "Styles"), React.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(StylesGroup, {
    label: "Caption",
    onClearStyles: function onClearStyles() {
      return handleClearStyles('caption');
    }
  }, React.createElement(ElementStylesGroup, {
    element: selectedWidget.caption,
    onPropertyChange: getPropertyChangeHandler('caption')
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(StylesGroup, {
    label: "Header",
    onClearStyles: function onClearStyles() {
      return handleClearStyles('header');
    }
  }, React.createElement(ElementStylesGroup, {
    element: selectedWidget.header,
    onPropertyChange: getPropertyChangeHandler('header')
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(StylesGroup, {
    label: "Table",
    onClearStyles: function onClearStyles() {
      return handleClearStyles('');
    }
  }, React.createElement(ElementStylesGroup, {
    element: selectedWidget,
    onPropertyChange: getPropertyChangeHandler('')
  }))))));
};

export default TableProperties;